<template>
    <md-content class="md-scrollbar">
        <div class="dashboard md-alignment-horizontal">            
            <div class="full-control" v-if="folderStructure.length > 0">
                <div class="list">                   
                    <md-subheader>Available assets</md-subheader>
                    <!-- render list of top level assets folders -->
                    <md-list>

                        <md-list-item md-expand v-for="topFolder in folderStructure"  :key="topFolder.topFolderName" :md-expanded.sync="expand[topFolder.topFolderName]">
                            <md-icon>folder</md-icon>
                            <span class="md-list-item-text">{{topFolder.topFolderName}}</span>

                                <!-- render 2nd level assets folders  -->
                            <md-list slot="md-expand">
                                <md-list-item md-expand class="md-inset" v-for="folder in topFolder.containsFolders" :key="folder.subFolderName">
                                    <md-icon>folder</md-icon>
                                    <span class="md-list-item-text">{{folder.subFolderName}}</span>

                                    <md-list slot="md-expand">
                                        <!-- third level files -->
                                        <md-list-item v-for="file in folder.containsFiles" :key="file.name" class="md-inset">

                                            <md-list-item v-if="file.href == '/'" class="md-layout">
                                                <div class="md-list-item-text md-layout-item">
                                                    <span>{{file.name}}</span>
                                                </div>
                                                <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-25 md-xsmall-size-30">
                                                    <md-button class="md-icon-button md-list-action" @click.stop="getDownloadURL(file)">
                                                        <md-tooltip md-direction="top">Click to start download</md-tooltip>
                                                        <md-icon>save</md-icon>
                                                    </md-button>
                                                    <md-button class="md-icon-button md-list-action" @click.stop="openDeletePrompt(file)">
                                                        <md-tooltip md-direction="top">Click to delete asset</md-tooltip>
                                                        <md-icon>delete</md-icon>
                                                    </md-button>
                                                </div>
                                            </md-list-item>

                                            <md-list-item v-if="file.filedownloaded" class="md-layout">
                                                <div class="md-list-item-text md-layout-item">
                                                    <md-tooltip md-direction="top">Asset already downloaded</md-tooltip>
                                                    <span>{{file.name}}</span>
                                                </div>
                                                <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-25 md-xsmall-size-30">
                                                    <md-icon>check</md-icon>
                                                    <md-button class="md-icon-button md-list-action" @click.stop="openDeletePrompt(file)">
                                                        <md-tooltip md-direction="top">Click to delete asset</md-tooltip>
                                                        <md-icon>delete</md-icon>
                                                    </md-button>
                                                </div>
                                            </md-list-item>

                                        </md-list-item>

                                    </md-list>
                                </md-list-item>

                                <!-- render 2nd level assets files  -->
                                <md-list>
                                    <!-- second level files -->
                                    <md-list-item v-for="file in topFolder.containsFiles" :key="file.name" class="md-inset">

                                        <md-list-item v-if="file.href == '/'" class="md-inset md-layout">
                                            <div class="md-list-item-text md-layout-item">
                                                <span>Click to download: {{file.name}}</span>
                                            </div>
                                            <div class="md-layout-item md-xlarge-size-10 md-large-size-20 md-medium-size-10 md-xsmall-size-10">
                                                <md-button class="md-icon-button md-list-action" @click.stop="getDownloadURL(file)">
                                                    <md-tooltip md-direction="top">Click to start download</md-tooltip>
                                                    <md-icon>save</md-icon>
                                                </md-button>
                                                <md-button class="md-icon-button md-list-action" @click.stop="openDeletePrompt(file)">
                                                    <md-tooltip md-direction="top">Click to delete asset</md-tooltip>
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                            </div>
                                        </md-list-item>

                                        <md-list-item v-if="file.filedownloaded" class="md-inset md-layout">
                                            <div class="md-list-item-text md-layout-item">
                                                <md-tooltip md-direction="top">Asset already downloaded</md-tooltip>
                                                <span>{{file.name}}</span>
                                            </div>
                                            <div class="md-layout-item md-xlarge-size-10 md-large-size-20 md-medium-size-10 md-xsmall-size-10">
                                                <md-icon>check</md-icon>
                                                <md-button class="md-icon-button md-list-action" @click.stop="openDeletePrompt(file)">
                                                    <md-tooltip md-direction="top">Click to delete asset</md-tooltip>
                                                    <md-icon>delete</md-icon>
                                                </md-button>
                                            </div>
                                        </md-list-item>

                                    </md-list-item>

                                </md-list>


                            </md-list>

                        </md-list-item>
                    </md-list>
                </div>
            </div>

            <md-subheader>User uploaded areas</md-subheader>
            <AssetsList
                v-if="uploadedAssets.length > 0"
                :assetsList="uploadedAssets"
                :user="prom"
                @asset-deleted="refreshAssets()"/>
            <p v-else class="md-caption">You don't have any uploaded areas</p>
        </div>
        <md-dialog-confirm
            :md-active.sync="deleteDialog.visible"
            :md-content="deleteDialog.message"
            md-confirm-text="Delete"
            md-cancel-text="Cancel"
            @md-cancel="cancelDelete()"
            @md-confirm="deleteAssetFromStorage()" />
    </md-content>
</template>


<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { storage } from "@/firebase.js";
import { AuthService } from "@/services/auth.service";
import { AssetsService } from "@/services/assets.service";
import { functions } from "@/firebaseFunctions.js";
import AssetsList from "@/components/AssetsList"


export default {
    name: "Assets",
    components: {
        AssetsList,
    },
    data: () => ({
        prom:{},
        folderStructure: [],
        expandSingle: true,
        userStoragePath: '',
        downloadLinks: [],
        expand: {},
        deleteDialog: {
            visible: false,
            message: "",
        },
        fileToDelete: null,
        userAssetsResponse: null,
        uploadedAssets: []
    }),
    watch: {
        uploadedAssets: {
            deep: true,
            immediate: true,
            handler: function(newVal) {
                return newVal
            }
        }
    },
    created() {
        this.subscription = AuthService.loggedUser$.subscribe((user) => {
            this.prom = user;
            console.log('this.prom', this.prom)
        });

        let data = {
            "org_id": this.prom.orgId,
            "user_id": this.prom.uid,
        };
        try {
            functions.geeUserAssets(data).then((response) => {
                console.info(response)
                this.userAssetsResponse = response

                if (this.userAssetsResponse.data.assets) {
                    this.processUploadedAssets(this.userAssetsResponse.data.assets)
                }
            });
        } catch(e) {
            console.error("Error in gee upload status, cancelling poller", e);
        }

        this.userStoragePath = 'organisations/'+ this.prom.orgId+'/'+this.prom.uid;


        this.assetsUpdateSubscription = AssetsService.assetUpdate$.subscribe(() => {

            this.folderStructure = [];

            storage.ref().child(this.userStoragePath).listAll().then(function (result) {

                // ----------------------
                // first level folders
                result.prefixes.forEach((topFolderRef) => {

                    var topFolderStructure = {
                        topFolderName: '',
                        expanded: false,
                        containsFolders: [],
                        containsFiles: []
                    };
                    topFolderStructure.topFolderName = topFolderRef.name;
                    // ----------------------
                    // second level folders + files
                    topFolderRef.listAll().then((subLevel) => {

                        var subFiles = [];
                        var subFolders = [];

                        if (subLevel.items.length > 0) {
                            // second level files
                            subLevel.items.forEach((file) => {
                                subFiles.push({"name":file.name, "fullPath":file.fullPath ,"href":"/", "filedownloaded":false });
                            });

                            topFolderStructure.containsFiles = subFiles;
                        }

                        if (subLevel.prefixes.length > 0) {
                            // second level folders
                            subLevel.prefixes.forEach((folder) => {
                                var subFolderStructure = {
                                    subFolderName: '',
                                    containsFolders: [],
                                    containsFiles: []
                                };
                                subFolderStructure.subFolderName = folder.name;

                                // ----------------------
                                // third level folders + files
                                folder.listAll().then((finalLevel) => {
                                    var subSubFiles = [];

                                    // third level files
                                    if (finalLevel.items.length > 0) {

                                        finalLevel.items.forEach((file) => {
                                            subSubFiles.push( {"name":file.name,  "fullPath":file.fullPath,  "href":"/" , "filedownloaded":false});
                                        });

                                        subFolderStructure.containsFiles = subSubFiles;
                                    }

                                });
                                subFolders.push(subFolderStructure);
                            });

                            topFolderStructure.containsFolders = subFolders;
                        }
                    });
                    this.folderStructure.push(topFolderStructure);
                });
            }.bind(this));
        });
    },
    beforeDestroy() {
        //disconnect from firebase
        this.subscription.unsubscribe();
        this.assetsUpdateSubscription.unsubscribe();
    },
    methods: {
        // make a copy of EE assets for user that are ready to render
        processUploadedAssets(assets) {
            this.uploadedAssets = []
            assets.forEach((entry) => {
                let processedName = entry.name.split('/')
                let assetData = {
                    id: entry.id,
                    name: processedName[processedName.length-1],
                    type: entry.type
                }
                this.uploadedAssets.push(assetData)
            });
        },
        openDeletePrompt(file) {
            this.fileToDelete = null;
            this.fileToDelete = file;
            this.deleteDialog.visible = true;
            this.deleteDialog.message = `Are you sure you want to delete the asset `+ file.name + `?. This is an irreversible action.`;
        },
        cancelDelete() {
            this.deleteDialog.visible = false;
            this.deleteDialog.message = "";
            this.fileToDelete = null;
        },
        deleteAssetFromStorage() {
            // Create a storage reference from our storage service
            const storageRef = storage.ref();
            const downloadfileRef = storageRef.child(this.fileToDelete.fullPath);
            // Delete the file
            downloadfileRef.delete().then(() => {
            // File deleted successfully
                AssetsService.updateAssets();
            });
            this.fileToDelete = null;
        },
        getDownloadURL(file){
            // Create a storage reference from our storage service
            const storageRef = storage.ref();
            const downloadfileRef = storageRef.child(file.fullPath);

            downloadfileRef.getDownloadURL().then( (url)  => {
                console.log("generated downlaod url:" + url) ;
                file.href = url ;

                let element = document.createElement('a');

                element.setAttribute('download', '');
                element.setAttribute('target', '_blank');
                element.setAttribute('href', file.href);
                element.setAttribute('type', 'image/tiff');
                element.style.display = 'none';

                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);

                file.filedownloaded = true ;
            })
            .catch((error) => {
                console.log("error obtaining downlaodurl:" + error ) ;
            });
        },
        refreshAssets() {
            // reload user assets when one is deleted.
            let data = {
                "org_id": this.prom.orgId,
                "user_id": this.prom.uid,
            };
            try {
                functions.geeUserAssets(data).then((response) => {
                    this.userAssetsResponse = response
                    if (this.userAssetsResponse.data.assets) {
                        this.processUploadedAssets(this.userAssetsResponse.data.assets)
                    }
                });
            } catch(e) {
                console.error("Error in gee upload status, cancelling poller", e);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    $list-width: 100%;

    .full-control {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
    }

    .list {
        width: $list-width;
    }

    .full-control > .md-list {
        width: $list-width;
        max-width: 100%;
        height: 400px;
        display: inline-block;
        overflow: auto;
        border: 1px solid rgba(#000, .12);
        vertical-align: top;
    }
    .md-list-item.nested-padding {
        padding-left: 20px;
    }
</style>